
(function () {
  var MODE = 'session', DAYS = 1, KEY = 'rfkl:seen';
  var HOME = ['/', '/index.html'];
  var skip = false, seen = false;

  /* Marked on EVERY page, not just the homepage. The loader is an arrival
     moment: if someone landed on an interior page and later clicks "Home",
     firing a 6s intro mid-session ambushes them. Flip this to only mark when
     the loader actually plays if you want the opposite. */
  try {
    if (MODE === 'session') {
      seen = !!sessionStorage.getItem(KEY);
      sessionStorage.setItem(KEY, '1');
    } else if (MODE === 'daily') {
      var last = +localStorage.getItem(KEY) || 0;
      seen = Date.now() - last < DAYS * 864e5;
      if (!seen) localStorage.setItem(KEY, String(Date.now()));
    }
  } catch (e) {}          // storage blocked (private mode, sandboxed iframe)
                          // -> seen stays false -> it PLAYS. Failing to the
                          //    intended experience beats failing to a blank screen.
  if (seen) skip = true;

  var here = location.pathname.replace(/\/+$/, '') || '/';
  var atHome = HOME.some(function (h) { return (h.replace(/\/+$/, '') || '/') === here; });
  if (!atHome) skip = true;                                // homepage only

  try {
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') skip = true;   // returning via Back
  } catch (e) {}

  if (location.hash) skip = true;                          // shared deep link
  if (/[?&]loader=1/.test(location.search)) skip = false;  // force replay, for demos

  if (skip) document.documentElement.classList.add('rfkl-skip');
})();
